import React, { Fragment } from "react";
import {Row, Col, Card, Button} from "react-bootstrap";


const ProblemType = ({ pbtype }) => {

   const imgsrc = "images/challenges/" + pbtype.problemtypename + "-small.png";
   var level = "";
   var bcolor = "border-success";
   var tcolor = "text-success";
   var problemtypeid = pbtype.problemtypeid;
   var url = "";

   if(pbtype.problemlevel == "Foundational" || pbtype.problemlevel == "Beginner"){
      level = "Easy";
      bcolor = "border-success";
      tcolor = "text-success";
   }

   if(pbtype.problemlevel == "Intermediate"){
      level = "Medium";
      bcolor = "border-warning";
      tcolor = "text-warning";
   }

   if(pbtype.problemlevel == "Advanced"){
      level = "Hard";
      bcolor = "border-danger";
      tcolor = "text-danger";

   }

   if(pbtype.categoryid == 8){
      url = '/project/'+problemtypeid;
   }
   else {
      url = '/problem/list/'+problemtypeid;
   }

   if(pbtype.categoryid == 8){
      return(
         <Fragment>
            
               <Card className={bcolor} key={pbtype.problemtypeid}>
                  <Row>
                     <Col className="col-12 col-md-3">
                        <img className="card-img-top img-fluid"
                        src={imgsrc}
                        height="100%"
                        width = "100%"
                        alt="Problem Type"
                        />
                        
                     </Col>
                     <Col className="col-12 col-md-9">
                        <Card.Body>
                           <Card.Title>{pbtype.problemtypename}</Card.Title>
                           <Card.Text>       
                              {`${pbtype.description.substring(0, 150)}...`}
                           </Card.Text>
                           <Button variant="primary" href={url}>Learn More</Button>
                        </Card.Body>
                     </Col>
                  </Row>
               </Card>
           
         </Fragment>
      );
   }
   else {
      return(
         <Fragment>
            <Col className="col-12 col-md-4 ps-0 pt-3 d-flex" key={pbtype.problemtypeid}>
               <Card className={bcolor}>
                  <Row>
                     <Col>
                     <img className="card-img-top img-fluid"
                        src={imgsrc}
                        height="100%"
                        width = "100%"
                        alt="Problem Type"
                     />
                        
                     </Col>
                     <Col>
                        <p className="small"> <b> Level: </b> <span className={tcolor}> {level} </span></p>
                        <p className="small"> <b> Time: </b> {pbtype.completiontime}</p>
                     </Col>
                  </Row>
                  <Card.Body>
                     <Card.Title>{pbtype.problemtypename}</Card.Title>
                     <Card.Text>       
                        {`${pbtype.description.substring(0, 100)}...`}
                     </Card.Text>
                     <Button variant="primary" href={url}>Learn More</Button>
                  </Card.Body>
               </Card>
            </Col>
         </Fragment>
      );
   }


};

export default ProblemType;